import { storageService } from '../infrastructure/storage/storageService';

// Unified platform-agnostic storage helper backed by storageService
export async function setItem(key: string, value: string): Promise<void> {
  try {
    storageService.set(key, value);
  } catch (e) {
    // swallow quota / private-mode errors
  }
}

export async function getItem(key: string): Promise<string | null> {
  try {
    return storageService.get(key);
  } catch (e) {
    return null;
  }
}

export async function removeItem(key: string): Promise<void> {
  try {
    storageService.remove(key);
  } catch (e) {
    // ignore
  }
}

export const STORAGE_KEYS = {
  THEME: 'app_theme',
  TEMPLATE: 'app_theme_template',
  LAYOUT: 'app_layout',
};

export default { setItem, getItem, removeItem, STORAGE_KEYS };

